module.exports = __webpack_public_path__ + "img/american-express.28f03f2d.png";